/** Eenmalige focus-hint bij zichtbare lijst-play-knop; schrijft focusHint bij tonen. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_FOCUS } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import {
  isDesktopBreakpoint,
  useBreakpoint,
} from '@/hooks/ui/useBreakpoint';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.playTargetVisible
 * @param {string | undefined} params.userId
 * @param {string | null | undefined} params.activeFocusTaskId
 */
export function useFocusPlayHint({
  playTargetVisible,
  userId,
  activeFocusTaskId,
}) {
  const breakpoint = useBreakpoint();
  const isDesktop = isDesktopBreakpoint(breakpoint);
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (initRef.current) {
      return;
    }
    if (!playTargetVisible || !userId || !profileLoaded || !isDesktop) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_FOCUS)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_FOCUS);
  }, [playTargetVisible, userId, profileLoaded, seenHints, isDesktop]);

  useEffect(() => {
    if (activeFocusTaskId) {
      setOpen(false);
    }
  }, [activeFocusTaskId]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
